// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.members-info .btns .btns-list[data-v-f3a48a5c] {
  margin-bottom: 0;
}
.members-info .members[data-v-f3a48a5c] {
  position: relative;
  height: 100%;
  overflow-y: auto;
}
.members-info .custom-btn[data-v-f3a48a5c] .item-cont > * {
  padding-left: 7px;
}
.members-info .custom-btn[data-v-f3a48a5c] .btn-list-item .btn-text {
  margin-left: 7px;
}
.members-info .info-section[data-v-f3a48a5c] {
  padding: 0;
  margin-bottom: 0 !important;
}
.members-info .info-section .item-cont[data-v-f3a48a5c] {
  overflow: hidden;
  margin: 0;
}
.members-info .info-section .item-cont .list-item[data-v-f3a48a5c] {
  cursor: pointer;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  height: 68px;
  width: 100%;
  overflow: hidden;
  padding-left: 10px;
  padding-right: 10px;
}
.members-info .info-section .item-cont .list-item[data-v-f3a48a5c]:not(:last-child)::after {
  content: " ";
  position: absolute;
  bottom: 0;
  display: inline-block;
  width: 100%;
  border-bottom: 1px solid var(--border-bottom-selecteditems);
  padding-top: 5px;
}
.members-info .info-section .item-cont .list-item .fio[data-v-f3a48a5c],
.members-info .info-section .item-cont .list-item .btn-text[data-v-f3a48a5c] {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.members-info .info-section .item-cont .btn-list-item > *[data-v-f3a48a5c] {
  margin: auto 0;
}
.members-info .info-section .item-cont .btn-list-item .btn-icon[data-v-f3a48a5c] {
  font-size: 18px;
  width: 48px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border-radius: 50%;
  background-color: var(--icon-bgcolor2);
  margin: auto 2px;
  color: var(--icon-color);
}
.members-info .info-section .item-cont .btn-list-item[data-v-f3a48a5c] .btn-text {
  margin-left: 12px;
  color: var(--icon-bgcolor2);
}
.members-info .info-section .item-cont .member-list-item[data-v-f3a48a5c] > * {
  margin: auto 2px;
}
.members-info .info-section .item-cont .member-list-item .fio-block[data-v-f3a48a5c] {
  flex: 1;
  overflow: hidden;
}
.members-info .info-section .item-cont .member-list-item .fio-block.compact[data-v-f3a48a5c] {
  line-height: 1.25em;
}
.members-info .info-section .item-cont .member-list-item .fio-block > *[data-v-f3a48a5c] {
  margin: auto 10px;
}
.members-info .info-section .item-cont .member-list-item .fio-block .member-text[data-v-f3a48a5c] {
  line-height: 1.12em;
  color: gray;
  font-size: 13px;
}
.members-info .info-section .item-cont .member-list-item .member-privilege[data-v-f3a48a5c] {
  color: var(--special-blue-color);
  font-size: 11px;
}
.members-info .info-section .item-cont .member-list-item .member-privilege span[data-v-f3a48a5c] {
  padding: 0.4em 0.8em;
  border: 1px solid var(--special-blue-color);
  border-radius: 12px;
}
.members-info .info-section .item-cont .member-list-item .del-user[data-v-f3a48a5c] {
  margin-left: auto;
  width: 20px;
}
.members-info .info-section .item-cont .member-list-item .del-user[data-v-f3a48a5c]:hover {
  color: var(--toolbtn-color-hover);
}
.members-info .info-section .item-cont .member-list-item[data-v-f3a48a5c] .circle-animation {
  width: 30px;
  height: 30px;
}
[data-v-f3a48a5c] .loader {
  height: calc(100%);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/info/MembersInfo.vue"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,2DAA2D;EAC3D,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".members-info .btns .btns-list[data-v-f3a48a5c] {\n  margin-bottom: 0;\n}\n.members-info .members[data-v-f3a48a5c] {\n  position: relative;\n  height: 100%;\n  overflow-y: auto;\n}\n.members-info .custom-btn[data-v-f3a48a5c] .item-cont > * {\n  padding-left: 7px;\n}\n.members-info .custom-btn[data-v-f3a48a5c] .btn-list-item .btn-text {\n  margin-left: 7px;\n}\n.members-info .info-section[data-v-f3a48a5c] {\n  padding: 0;\n  margin-bottom: 0 !important;\n}\n.members-info .info-section .item-cont[data-v-f3a48a5c] {\n  overflow: hidden;\n  margin: 0;\n}\n.members-info .info-section .item-cont .list-item[data-v-f3a48a5c] {\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  height: 68px;\n  width: 100%;\n  overflow: hidden;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.members-info .info-section .item-cont .list-item[data-v-f3a48a5c]:not(:last-child)::after {\n  content: \" \";\n  position: absolute;\n  bottom: 0;\n  display: inline-block;\n  width: 100%;\n  border-bottom: 1px solid var(--border-bottom-selecteditems);\n  padding-top: 5px;\n}\n.members-info .info-section .item-cont .list-item .fio[data-v-f3a48a5c],\n.members-info .info-section .item-cont .list-item .btn-text[data-v-f3a48a5c] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.members-info .info-section .item-cont .btn-list-item > *[data-v-f3a48a5c] {\n  margin: auto 0;\n}\n.members-info .info-section .item-cont .btn-list-item .btn-icon[data-v-f3a48a5c] {\n  font-size: 18px;\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n  text-align: center;\n  border-radius: 50%;\n  background-color: var(--icon-bgcolor2);\n  margin: auto 2px;\n  color: var(--icon-color);\n}\n.members-info .info-section .item-cont .btn-list-item[data-v-f3a48a5c] .btn-text {\n  margin-left: 12px;\n  color: var(--icon-bgcolor2);\n}\n.members-info .info-section .item-cont .member-list-item[data-v-f3a48a5c] > * {\n  margin: auto 2px;\n}\n.members-info .info-section .item-cont .member-list-item .fio-block[data-v-f3a48a5c] {\n  flex: 1;\n  overflow: hidden;\n}\n.members-info .info-section .item-cont .member-list-item .fio-block.compact[data-v-f3a48a5c] {\n  line-height: 1.25em;\n}\n.members-info .info-section .item-cont .member-list-item .fio-block > *[data-v-f3a48a5c] {\n  margin: auto 10px;\n}\n.members-info .info-section .item-cont .member-list-item .fio-block .member-text[data-v-f3a48a5c] {\n  line-height: 1.12em;\n  color: gray;\n  font-size: 13px;\n}\n.members-info .info-section .item-cont .member-list-item .member-privilege[data-v-f3a48a5c] {\n  color: var(--special-blue-color);\n  font-size: 11px;\n}\n.members-info .info-section .item-cont .member-list-item .member-privilege span[data-v-f3a48a5c] {\n  padding: 0.4em 0.8em;\n  border: 1px solid var(--special-blue-color);\n  border-radius: 12px;\n}\n.members-info .info-section .item-cont .member-list-item .del-user[data-v-f3a48a5c] {\n  margin-left: auto;\n  width: 20px;\n}\n.members-info .info-section .item-cont .member-list-item .del-user[data-v-f3a48a5c]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.members-info .info-section .item-cont .member-list-item[data-v-f3a48a5c] .circle-animation {\n  width: 30px;\n  height: 30px;\n}\n[data-v-f3a48a5c] .loader {\n  height: calc(100%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
